import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { GiftcardDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchGiftcardPlans } from "../../../../features/auth/store/giftcardPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import Giftcard from "./Giftcard";

const GiftcardRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedGiftcardPlan, setSelectedGiftcardPlan] =
    useState<Product | null>(null);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { giftcardPlans, loading, error } = useSelector(
    (state: RootState) => state.giftcardPlans
  );

  useEffect(() => {
    const filters: any = {};

    // Only add status filter if it's not empty
    if (statusFilter && statusFilter !== "") {
      filters.status = statusFilter;
    }
    if (searchTerm && searchTerm !== "") {
      filters.search = searchTerm;
    }

    dispatch(fetchGiftcardPlans(filters));
  }, [dispatch, statusFilter, searchTerm]);

  // Transform GiftcardPlan to Product - ensuring all required fields are present

  const handleGiftcardPlanClick = (giftcardPlan: Product) => {
    setSelectedGiftcardPlan(giftcardPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedGiftcardPlan(null);
  };

  if (showDetailView && selectedGiftcardPlan) {
    return (
      <GiftcardDetailView
        giftcardPlan={{
          ...selectedGiftcardPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <Giftcard
      giftcardPlans={giftcardPlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onGiftcardPlanClick={handleGiftcardPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default GiftcardRouter;
